import { apiSlice } from './apiSlice';
import { ENDPOINTS } from '../../shared/constants/urls';

export const projectApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // PROJECT INFOS ON THE WEB
    getProjectOnlineInfos: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.PROJECTS}/infos/${id}/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
    }),
    // PROJECT SELECTION
    selectProject: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/select/${data.id}/`,
        method: 'POST'
      }),
      extraOptions: { requiresAuth: true },
    }),
    getSelectedProject: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.PROJECTS}/selected/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
    }),
    // CRUD PROJECT
    createProject: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/`,
        method: 'POST',
        body: data,
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Projects']
    }),
    updateIntegration: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/integration/${data.id}/`,
        method: 'PUT',
        body: data,
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Projects']
    }),
    getAllProjects: builder.query({
      query: () => ({
        url: `${ENDPOINTS.PROJECTS}/`,
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
      providesTags: ['Projects']
    }),
    getProject: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.PROJECTS}/${id}/`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
    }),
    updateSingleProject: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/${data.id}/`,
        method: 'PUT',
        body: data,
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Projects']
    }),
    deleteSingleProjects: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.PROJECTS}/${id}/`,
        method: 'DELETE',
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Projects']
    }),
    deleteSelectedProjects: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/selection/`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }),
      extraOptions: { requiresAuth: true },
      invalidatesTags: ['Projects']
    }),
    // EXPORT BLOG POSTS
    exportBlogPost: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.PROJECTS}/export-blog-post/${data.id}/`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }),
      extraOptions: { requiresAuth: true }
    }),
  }),
});

export const {
  useGetProjectOnlineInfosMutation,
  useCreateProjectMutation,
  useUpdateIntegrationMutation,
  useSelectProjectMutation,
  useGetSelectedProjectMutation,
  useDeleteSelectedProjectsMutation,
  useDeleteSingleProjectsMutation,
  useGetAllProjectsQuery,
  useGetProjectMutation,
  useUpdateSingleProjectMutation,
  useExportBlogPostMutation
} = projectApiSlice;
